import React, { Suspense, lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import AboutMe from './components/about/AboutMe.js';
import PeakDetection from './components/ecg/PeakDetection.js';
import Home from './components/home/Home.js';
import NavBar from './components/nav/NavBar.js';
import OptionsPricer from './components/optionsPricer/OptionsPricer.js';

const ResidencySchedule = lazy(() => import('./components/residencySchedule/ResidencySchedule.js'));

const RootContainer = ({ children }) => {
  const { pathname } = useLocation();
  const isResidencySchedule = /^\/projects\/residency_schedule\/?$/.test(pathname);
  const isHome = pathname === '/';

  return (
    <div
      key="root-content"
      className={`flex col root-container${isResidencySchedule ? ' residency-root-container' : ''}${isHome ? ' home-root-container' : ''}`}
    >
      <NavBar />
      <div
        className={`content-container${isResidencySchedule ? ' residency-content-container' : ''}${isHome ? ' home-content-container' : ''}`}
      >
        {children}
      </div>
    </div>
  );
};

const RootRouter = () => (
  <RootContainer>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/about" component={AboutMe} />
      <Route exact path="/projects/options_pricer" component={OptionsPricer} />
      <Route
        exact
        path="/projects/residency_schedule"
        render={() => (
          <Suspense fallback={<p role="status">Loading schedule…</p>}>
            <ResidencySchedule />
          </Suspense>
        )}
      />
      <Route exact path="/projects/ecg_peak_detection" component={PeakDetection} />
    </Switch>
  </RootContainer>
);

export default RootRouter;
